import vChatTeaser from "./v-chat-teaser.vue";
import vChatBubbleTeaser from "./v-chat-bubble-teaser.vue";

export default Vue => {
  Vue.component("v-chat-teaser", vChatTeaser);
  Vue.component("v-chat-bubble-teaser", vChatBubbleTeaser);
};
